import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { fetchMe } from 'redux/users/actions';
import {
  updateBillingPlanCryptocom,
  clearUpdateBillingPlanCryptocom,
} from 'redux/billing/actions';

import Script from 'react-load-script';

import { сryptopayButton } from './cryptopay';

import CommonMessage from 'components/common/CommonMessage';

import { CRYPTOCOM_PUBLISHABLE_KEY } from 'utils/restapi';

import './CryptopayButton.css';


function CryptopayButton(props) {
  const {
    fetchMe,
    updateBillingPlanCryptocom,
    clearUpdateBillingPlanCryptocom,
    me,
    interval,
    billingPlans,
    disabled,
    userBillingPlanUpdatedCryptocom,
    userBillingPlanUpdatedCryptocomError,
  } = props;

  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [scriptLoadedError, setScriptLoadedError] = useState(false);

  useEffect(() => {
    renderCryptopayButton();
  }, [scriptLoaded]);

  useEffect(() => {
    renderCryptopayButton();
  }, [interval]);

  useEffect(() => {
    if (userBillingPlanUpdatedCryptocom) {
      fetchMe();
      clearUpdateBillingPlanCryptocom();
    }
  }, [userBillingPlanUpdatedCryptocom]);

  const proPlan = billingPlans &&
    billingPlans.filter(plan => plan.title === 'Pro')[0];

  const onApproveFunction = data => {
    updateBillingPlanCryptocom(data, proPlan.id, interval);
  };

  const renderCryptopayButton = () => {
    if (scriptLoaded) {
      сryptopayButton(
        me.id,
        interval === 'month' ? 590 : 5880,
        interval,
        onApproveFunction,
      );
    }
  };

  const handleScriptError = () => {
    setScriptLoadedError(true);
  };

  const handleScriptLoad = () => {
    setScriptLoaded(true);
  };

  if (scriptLoadedError) return null;

  return (
    <div className="cryptopay-button__component">
      <Script
        url={`https://js.crypto.com/sdk?publishable-key=${CRYPTOCOM_PUBLISHABLE_KEY}`}
        onError={handleScriptError}
        onLoad={handleScriptLoad}
      />

      {disabled && <div className="disabled-layout" />}

      <div
        className="pay-button-wrapper"
        id="pay-button"
      />

      {userBillingPlanUpdatedCryptocomError &&
        <CommonMessage error>
          Subscription error..
        </CommonMessage>
      }
    </div>
  );
}

CryptopayButton.propTypes = {
  fetchMe: PropTypes.func.isRequired,
  updateBillingPlanCryptocom: PropTypes.func.isRequired,
  clearUpdateBillingPlanCryptocom: PropTypes.func.isRequired,
  me: PropTypes.object,
  interval: PropTypes.string.isRequired,
  billingPlans: PropTypes.arrayOf(PropTypes.shape),
  disabled: PropTypes.bool,
  userBillingPlanUpdatedCryptocom: PropTypes.object,
  userBillingPlanUpdatedCryptocomError: PropTypes.object,
};

CryptopayButton.defaultProps = {
  me: null,
  billingPlans: null,
  disabled: null,
  userBillingPlanUpdatedCryptocom: null,
  userBillingPlanUpdatedCryptocomError: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    billingPlans: state.billingReducer.billingPlans,
    userBillingPlanUpdatedCryptocom: state.billingReducer.userBillingPlanUpdatedCryptocom,
    userBillingPlanUpdatedCryptocomError: state.billingReducer.userBillingPlanUpdatedCryptocomError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    updateBillingPlanCryptocom,
    clearUpdateBillingPlanCryptocom,
  },
)(CryptopayButton);
